import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import ActivityPage from './pages/ActivityPage';
import SettingsPage from './pages/SettingsPage';

// Default settings
const DEFAULT_SETTINGS = {
  globalTimerEnabled: true,
  globalTimerValue: 300, // 5 minutes for the session
  localTimerEnabled: true,
  localTimerValue: 30 // 30 seconds per question
};

// Wrapper component to handle navigation
function AppContent() {
  const navigate = useNavigate();
  const [settings, setSettings] = useState(() => {
    // Load settings from localStorage or use defaults
    const savedSettings = localStorage.getItem('mathigami-settings');
    return savedSettings ? JSON.parse(savedSettings) : DEFAULT_SETTINGS;
  });

  // Save settings to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('mathigami-settings', JSON.stringify(settings));
  }, [settings]);

  return (
    <Routes>
      <Route 
        path="/" 
        element={
          <ActivityPage 
            settings={settings}
            onSettingsClick={() => navigate('/settings')} 
          />
        } 
      />
      <Route 
        path="/settings" 
        element={
          <SettingsPage 
            settings={settings}
            onSettingsChange={setSettings}
            onBack={() => navigate('/')}
          />
        } 
      />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
